<div class="grid place-content-center">
    <app-icon (click)="onLogoutClick()" class="text-black hover:cursor-pointer block" [name]="'material-symbols:logout'" />
</div>
